module.exports = __webpack_public_path__ + "static/media/loader.89497ec9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/loader.gif
// module id = 13
// module chunks = 0